export interface TableColumn {
    key: string,
    label: string,
    colType: string
}

export interface SaveAclRequest {
    id: string,
    resources: Array<Resource>
}

export interface Resource {
    name: string,
    resourceEntities: Array<ResourceEntity>
}

export interface ResourceEntity {
    id: string,
    name: string,
    jsonClaims: {} /** Only used on front-end for binding */
    claims: Array<Claim>
}

export interface Claim {
    name: string,
    value: boolean,
}

export interface PasswordReset {
    mailSent: boolean | null;
    somethingBadHappen: boolean | null;
    passwordReseted: boolean | null;
}

export interface AclMember {
    id: string,
    name: string,
    username: string,
    type: AclMemberType
}

export interface AclMemberDto {
    id: string,
    type: AclMemberType
}

export enum AclMemberType {
    User,
    UserGroup
}
export interface SSODtoIn {
    token: string
}

export interface AzureAdConfig {
    azureAppClientId: string,
    clientTenantId: string
}

export interface Acl {
    resourceId: string,
    type: string,
    name: string,
    claim: string,
    templateType: string
}

export interface EffectivePermissionAcl {
    resourceId: string,
    type: string,
    name: string,
    claim: string,
    resourceAccesses: Array<ResourceAccess>,
    userGroups: Array<AclUserGroup>,
    templateType: string
}

export enum ResourceAccess {
    Direct = "Direct",
    UserGroup = "UserGroup"
}

export interface AclUserGroup{
    groupId: string,
    groupName: string
}

export enum ResourceClaim {
    Access = "Access",
    Read = "Read"
}

export enum ResourceType {
    Channel = "Channel",
    Solution = "Solution",
    Folder = "Folder",
    ContentTemplate = "ContentTemplate"
}

export interface LegacyLoginDtoIn {
    userName: string;
    password: string;
}

export interface ValidateLegacyLoginDto {
    validated: boolean;
    isSharedUser: boolean;
}

export interface LegacyUpdateDtoIn {
    userName: string;
    password: string;
    email: string;
}

export interface LegacyCreateUserDtoIn {
    userName: string;
    password: string;
    email: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    phoneNumber: string;
}
